(() => {
  if (window.__cmConversionGuardReady) return;
  window.__cmConversionGuardReady = true;

  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
  const idle = window.requestIdleCallback || ((callback) => window.setTimeout(callback, 180));
  let runQueued = false;
  let pendingContrast = false;
  let lastContrastAt = 0;
  let highPriorityImageSet = false;
  let cartFetchPayload = null;
  let cartFetchAt = 0;
  let cartFetchInflight = null;
  let resizeTimer;

  function isCart() {
    const root = $('[data-cx-root]');
    return location.pathname.replace(/\/$/, '') === '/cart' || !!(root && root.classList.contains('cx-template-cart'));
  }

  function isCartDrawerOpen() {
    return !!$('cart-drawer.active, cart-drawer.animate.active, cart-drawer[open], #CartDrawer.active, .cart-drawer.active');
  }

  function isCartSurface() {
    return isCart() || isCartDrawerOpen();
  }

  function isAcademiaSurface() {
    const path = location.pathname.replace(/\/$/, '');
    return path === '/pages/cosemania-formacion' ||
      path === '/pages/academia-cosemania' ||
      path.includes('/apps/my/courses') ||
      path.includes('/products/curso-profesional-de-mecanica-y-mantenimiento-de-maquinas-de-coser-domesticas') ||
      path.includes('/products/curso-mantenimiento-reparacion-maquinas-industriales') ||
      path.includes('/products/academia-cosemania');
  }

  function isProduct() {
    const root = $('[data-cx-root]');
    return location.pathname.includes('/products/') || !!(root && root.classList.contains('cx-template-product'));
  }

  function requestUrl(input) {
    if (typeof input === 'string') return input;
    if (input instanceof URL) return input.href;
    return input?.url || '';
  }

  function requestMethod(input, init = {}) {
    return String(init.method || input?.method || 'GET').toUpperCase();
  }

  function sameOriginPath(value) {
    try {
      const url = new URL(value, location.origin);
      return url.origin === location.origin ? url.pathname : '';
    } catch (error) {
      return '';
    }
  }

  function responseFromPayload(payload) {
    return new Response(payload.text, {
      status: payload.status,
      statusText: payload.statusText,
      headers: payload.headers
    });
  }

  function clearCartFetchCache() {
    cartFetchPayload = null;
    cartFetchAt = 0;
  }

  function installCartFetchCoalescing() {
    if (window.__cmCartFetchCoalescing || typeof window.fetch !== 'function' || typeof window.Response !== 'function') return;
    window.__cmCartFetchCoalescing = true;

    const nativeFetch = window.fetch.bind(window);
    window.fetch = (input, init = {}) => {
      const path = sameOriginPath(requestUrl(input));
      const method = requestMethod(input, init);

      if (method !== 'GET' && /^\/cart\/(add|change|update|clear)\.js$/.test(path)) {
        clearCartFetchCache();
        return nativeFetch(input, init);
      }

      if (method === 'GET' && path === '/cart.js') {
        if (cartFetchPayload && Date.now() - cartFetchAt < 900) {
          return Promise.resolve(responseFromPayload(cartFetchPayload));
        }

        if (!cartFetchInflight) {
          cartFetchInflight = nativeFetch(input, init).then(async (response) => {
            const payload = {
              text: await response.clone().text(),
              status: response.status,
              statusText: response.statusText,
              headers: [...response.headers.entries()]
            };
            if (response.ok) {
              cartFetchPayload = payload;
              cartFetchAt = Date.now();
            }
            return payload;
          }).finally(() => {
            cartFetchInflight = null;
          });
        }

        return cartFetchInflight.then(responseFromPayload);
      }

      return nativeFetch(input, init);
    };
  }

  function visible(element) {
    const rect = element.getBoundingClientRect();
    const style = getComputedStyle(element);
    return rect.width > 1 && rect.height > 1 && style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) > 0.05;
  }

  function directChild(container, element) {
    let node = element;
    while (node && node.parentElement && node.parentElement !== container) node = node.parentElement;
    return node && node.parentElement === container ? node : element;
  }

  function markTemplates() {
    const cart = isCart();
    const drawer = isCartDrawerOpen();
    document.documentElement.classList.toggle('cm-cart', cart);
    document.documentElement.classList.toggle('cm-cart-drawer-open', drawer);
    document.documentElement.classList.toggle('cm-cart-surface', cart || drawer);
    document.documentElement.classList.toggle('cm-product', isProduct());
    document.documentElement.classList.toggle('cm-academia-surface', isAcademiaSurface());
  }

  function moveShippingLine() {
    const line = $('[data-cm-shipping-line]');
    if (!line) return;
    if (isAcademiaSurface()) {
      line.hidden = true;
      return;
    }
    const header = $('.shopify-section-header, header, .header-wrapper');
    const main = $('main');
    if (header && header.nextElementSibling !== line) header.insertAdjacentElement('afterend', line);
    if (!header && main && main.firstElementChild !== line) main.insertAdjacentElement('afterbegin', line);
    line.hidden = false;
  }

  function moveCartShipping() {
    const panel = $('[data-cm-cart-shipping]');
    const main = $('main');
    if (!panel || !main) return;
    if (isAcademiaSurface()) {
      panel.hidden = true;
      return;
    }
    const anchor = $('.title-wrapper-with-link, .cart__warnings, h1', main) || $('cart-items, .cart-items, .cart__items, form[action="/cart"]', main) || main.firstElementChild || main;
    if (anchor === main) main.insertAdjacentElement('afterbegin', panel);
    else anchor.insertAdjacentElement('afterend', panel);
    panel.hidden = false;
  }

  function productShippingNote() {
    if (isAcademiaSurface()) {
      $$('[data-cm-product-shipping-note]').forEach((element) => element.remove());
      return;
    }
    if (!isProduct() || $('[data-cm-product-shipping-note]')) return;
    const info = $('.product__info-container');
    const form = info && $('product-form, form[action*="/cart/add"], .product-form', info);
    if (!info || !form) return;
    const note = document.createElement('div');
    note.className = 'cm-product-shipping-note';
    note.dataset.cmProductShippingNote = 'true';
    note.innerHTML = '<strong>Gastos de env&iacute;o antes de pagar</strong><span>Pen&iacute;nsula: 5,90 &euro; hasta 49,99 &euro; y gratis desde 50 &euro;. Baleares/Ceuta/Melilla: 6,90 &euro; y gratis desde 75 &euro;. Canarias: desde 11,95 &euro; seg&uacute;n peso.</span>';
    directChild(info, form).insertAdjacentElement('afterend', note);
  }

  function clearSuppressedObstacles() {
    $$('[data-cm-cart-suppressed="true"]').forEach((element) => {
      element.removeAttribute('data-cm-cart-suppressed');
      element.removeAttribute('aria-hidden');
    });
    $$('shopify-forms-embed, shopify-chat').forEach((element) => {
      if (!element.shadowRoot) return;
      const style = element.shadowRoot.getElementById('cm-cart-shadow-suppress');
      if (style) style.remove();
    });
  }

  function suppressShadowObstacles(element) {
    if (!element.shadowRoot) return;

    let style = element.shadowRoot.getElementById('cm-cart-shadow-suppress');
    if (!style) {
      style = document.createElement('style');
      style.id = 'cm-cart-shadow-suppress';
      element.shadowRoot.appendChild(style);
    }

    style.textContent = [
      '#app-embed',
      '.appEmbed',
      '[data-testid="app-router"]',
      '[data-testid="form-teaser"]',
      '.activator-nudge',
      'button.activator'
    ].join(',') + '{display:none!important;visibility:hidden!important;pointer-events:none!important;opacity:0!important;transform:scale(0)!important}';
  }

  function suppressMobileCartObstacles() {
    if (!isCartSurface() || window.innerWidth > 760) {
      clearSuppressedObstacles();
      return;
    }

    const selectors = [
      'shopify-chat',
      'shopify-forms-embed',
      '#ShopifyChat',
      '#shopify-chat',
      '[id*="shopify-chat" i]',
      '[id*="ShopifyChat" i]',
      '#app-embed-container-260559',
      '[id^="app-embed-container"]',
      '#PBarNextFrameWrapper',
      '[id^="PBar"]',
      '[id*="PBar"]',
      'body > .gta-widget.gta-bar',
      'body > [class*="gta-bar" i]',
      'body > [class*="GSC-BAR" i]',
      '[class*="pbar" i]',
      '[class*="privy" i]',
      '[class*="klaviyo-form" i]'
    ].join(',');

    $$(selectors).forEach((element) => {
      if (element.closest('.cm-cart-paybar, .shopify-pc__banner, .shopify-pc__prefs')) return;
      element.dataset.cmCartSuppressed = 'true';
      element.setAttribute('aria-hidden', 'true');
      suppressShadowObstacles(element);
    });

    const words = /(descuento|discount|5%|primer pedido|coupon|cupon|popup|privy|klaviyo|pbar|necesitas ayuda|ayuda|chat|inbox|gsc|gta)/i;
    $$('body > div, body > aside, body > section, body > iframe, body > shopify-chat, body > shopify-forms-embed').forEach((element) => {
      if (element.closest('.cm-cart-paybar, .shopify-pc__banner, .shopify-pc__prefs')) return;
      const rect = element.getBoundingClientRect();
      const style = getComputedStyle(element);
      const shadowText = element.shadowRoot ? element.shadowRoot.textContent || '' : '';
      const text = `${element.id || ''} ${element.className || ''} ${element.textContent || ''} ${shadowText}`;
      if ((style.position === 'fixed' || element.tagName === 'SHOPIFY-FORMS-EMBED') && rect.bottom > window.innerHeight - 260 && words.test(text)) {
        element.dataset.cmCartSuppressed = 'true';
        element.setAttribute('aria-hidden', 'true');
        suppressShadowObstacles(element);
      }
    });

    $$('shopify-forms-embed, shopify-chat').forEach(suppressShadowObstacles);
  }

  function parseColor(value) {
    const match = String(value || '').match(/rgba?\(([^)]+)\)/i);
    if (!match) return null;
    const parts = match[1].split(',').map((part) => Number.parseFloat(part.trim()));
    return parts.length >= 3 ? { r: parts[0], g: parts[1], b: parts[2], a: parts[3] ?? 1 } : null;
  }

  function lightness(color) {
    return (color.r * 0.2126 + color.g * 0.7152 + color.b * 0.0722) / 255;
  }

  function backgroundFor(element) {
    let node = element;
    while (node && node !== document.documentElement) {
      const color = parseColor(getComputedStyle(node).backgroundColor);
      if (color && color.a > 0.75) return color;
      node = node.parentElement;
    }
    return { r: 255, g: 255, b: 255, a: 1 };
  }

  function improveContrast() {
    lastContrastAt = Date.now();
    const selector = 'main h1,main h2,main h3,main p,main li,main span,main a,main summary,header a,header button,footer a,footer p,footer li,.card__heading,.card-information,.price,.badge,.banner__heading,.banner__text';
    $$(selector).filter((element) => element.dataset.cmContrastChecked !== 'true').slice(0, 220).forEach((element) => {
      if (!visible(element) || !(element.textContent || '').trim()) return;
      if (element.closest('.cm-cart-paybar, .cm-shipping-line, .cm-cart-shipping, .cm-product-shipping-note')) return;
      const fg = parseColor(getComputedStyle(element).color);
      const bg = backgroundFor(element);
      element.dataset.cmContrastChecked = 'true';
      if (!fg || Math.abs(lightness(fg) - lightness(bg)) > 0.42) return;
      element.classList.toggle('cm-readable-light', lightness(bg) > 0.45);
      element.classList.toggle('cm-readable-dark', lightness(bg) <= 0.45);
    });
  }

  function improveMediaHints() {
    $$('img:not([data-cm-perf-ready])').slice(0, 220).forEach((image) => {
      if (!image.hasAttribute('decoding')) image.setAttribute('decoding', 'async');
      const rect = image.getBoundingClientRect();
      if (!image.hasAttribute('loading') && rect.top > window.innerHeight * 1.15) image.setAttribute('loading', 'lazy');
      if (!highPriorityImageSet && !image.hasAttribute('fetchpriority') && rect.top >= 0 && rect.top < window.innerHeight * .85) {
        image.setAttribute('fetchpriority', 'high');
        highPriorityImageSet = true;
      }
      image.dataset.cmPerfReady = 'true';
    });

    $$('iframe:not([loading])').forEach((frame) => {
      const rect = frame.getBoundingClientRect();
      if (rect.top > window.innerHeight * 1.1) frame.setAttribute('loading', 'lazy');
    });
  }

  function hydratePanel(panel) {
    if (!panel) return;
    $$('img[data-cm-deferred-src]', panel).forEach((image) => {
      image.setAttribute('src', image.dataset.cmDeferredSrc);
      image.removeAttribute('data-cm-deferred-src');
    });
  }

  function deferInactiveFlowImages(root = document) {
    $$('.cm-flow__panel:not(.is-active) img[src]', root).forEach((image) => {
      if (image.dataset.cmDeferredSrc) return;
      image.dataset.cmDeferredSrc = image.getAttribute('src');
      image.removeAttribute('src');
      image.setAttribute('loading', 'lazy');
      image.setAttribute('decoding', 'async');
    });
    $$('.cm-flow__panel.is-active', root).forEach(hydratePanel);
  }

  function bindFlowHydration() {
    if (window.__cmFlowHydrationReady) return;
    window.__cmFlowHydrationReady = true;
    document.addEventListener('click', (event) => {
      const route = event.target.closest('[data-cm-route],[data-cm-route-shortcut]');
      if (!route) return;
      const routeName = String(route.dataset.cmRoute || route.dataset.cmRouteShortcut || '').replace(/[^\w-]/g, '');
      if (!routeName) return;
      requestAnimationFrame(() => hydratePanel($(`.cm-flow__panel[data-cm-panel="${routeName}"]`)));
    }, true);
  }

  function cleanupDuplicateGuidance() {
    if ($('[data-cm-flow-root]')) {
      $$('.cx-home,.cx-path,.cx-visual-menu,.cx-helper--collection').forEach((element) => {
        if (!element.closest('[data-cm-flow-root]')) element.remove();
      });
    }

    if (isProduct()) {
      $$('.cx-helper--product,.cx-bundle,[data-cx-product-helper],[data-cx-bundle],.shopify-payment-button,[id*="gsc_badges_buttons_icons" i],.blinks-widget,.blinks.GSC-HNNwjWcWAkehaMv').forEach((element) => element.remove());
    }
  }

  function run(options = {}) {
    installCartFetchCoalescing();
    markTemplates();
    moveShippingLine();
    moveCartShipping();
    productShippingNote();
    suppressMobileCartObstacles();
    cleanupDuplicateGuidance();
    bindFlowHydration();
    deferInactiveFlowImages();
    improveMediaHints();
    if (options.contrast || Date.now() - lastContrastAt > 3500) idle(improveContrast);
  }

  function scheduleRun(options = {}) {
    pendingContrast = pendingContrast || !!options.contrast;
    if (runQueued) return;
    runQueued = true;
    requestAnimationFrame(() => {
      runQueued = false;
      const contrast = pendingContrast;
      pendingContrast = false;
      run({ contrast });
    });
  }

  function mutationNeedsRun(mutations) {
    return mutations.some((mutation) => {
      return [...mutation.addedNodes].some((node) => {
        if (node.nodeType !== 1) return false;
        const text = `${node.tagName || ''} ${node.id || ''} ${node.className || ''}`;
        return /cart|drawer|shopify|PBar|privy|klaviyo|gta|gsc|product-form|announcement|utility|shipping|cx-|cm-/i.test(text);
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scheduleRun({ contrast: true }), { once: true });
  else scheduleRun({ contrast: true });

  window.addEventListener('shopify:section:load', () => scheduleRun({ contrast: true }));
  ['cart:updated', 'cart:refresh', 'cart:change'].forEach((eventName) => document.addEventListener(eventName, () => {
    clearCartFetchCache();
    scheduleRun();
  }));
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      $$('[data-cm-contrast-checked="true"]').forEach((element) => element.removeAttribute('data-cm-contrast-checked'));
      scheduleRun({ contrast: true });
    }, 180);
  }, { passive: true });
  [450, 1400, 3200].forEach((delay) => setTimeout(() => scheduleRun({ contrast: delay === 1400 }), delay));
  new MutationObserver((mutations) => {
    if (mutationNeedsRun(mutations)) scheduleRun();
  }).observe(document.body, { childList: true, subtree: true });
})();
